import { useContext, useMemo } from 'react';

import AuthContext from '../../context/authProvider';
import { formatContactNumber, formatPrice } from '../utils';

export function useAuthSettingUtils() {

    const { auth } = useContext(AuthContext);
    const { settings } = auth || {};
    const { currency } = auth || {};
    const { organization } = auth || {};
    return {

        getAuthSettings : () => {
            return settings;
        },
        getAuthSetting : (setting) => {
            if (!settings || typeof settings !== 'object') {
                return null;
            }
            return settings[setting] ?? null;
        },
        getAuthCurrency : () => {
            return currency;
        },
        getAuthOrganization : () => {
            return organization;
        },

    }
}

export function useAppSettingUtils() {

    const { auth } = useContext(AuthContext);
    const { settings } = auth || {};
    
    return {

        getAppSettings : () => {
            return settings;
        },
        getAppSetting : (setting) => {
            return  settings && typeof settings === 'object' ? (settings[setting] ?? null) : null;
        }           

    }
}

export function useFormatContactNumber() {
    const { auth } = useContext(AuthContext);
    const { settings } = auth || {};

    const pattern = (settings && settings.format_contact_number) || '(999) 999-9999';

    const formatter = useMemo(() => {
        return (raw) => formatContactNumber(raw, pattern);
    }, [pattern]);

    return formatter;
}


// import { useFormatPrice } from 'helpers/settings';
// const formatPrice = useFormatPrice();
// const display = formatPrice(line.total); // respects org's currency settings
export function useFormatPrice( options = {
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
} ) {
    const { auth } = useContext(AuthContext);
    const { currency } = auth || {};


    const formatter = useMemo(() => {
        return (value , opts = options) => {
            return formatPrice(value, {
                currency: currency.code,
                fallbackSymbol: currency.symbol,
                ...opts
            });
        };
    }, [currency.code, currency.symbol]);

    return formatter;
}




